<br>
<br>
<br>
<br>
<br>
<br>
<p>{{information}}</p>
<!-- {{scannerEnabled}} -->
<zxing-scanner *ngIf="!scannerEnabled" #scanner (scanSuccess)="scanSuccessHandler($event)">
</zxing-scanner>
<button (click)="enableScanner()" *ngIf="scannerEnabled" type="button" class="btn btn-success">Scan QR</button>
